import { FiHome, FiPlus, FiSettings, FiTool } from "react-icons/fi"

function NavButton({ active, children, update, current, width }) {
    return (
        <div
            className="button-wrapper"
            onClick={() => update(current)}
            style={{
                backgroundColor: active === current ? "var(--warnColor)" : "var(--card)",
                cursor: "pointer",
                flexDirection: "column",
                color: active === current ? '#fff' : 'var(--text)'
            }}
        >
            {children}
        </div>
    )
}

function Spacer({ width }) {
    return <div 
        style={{
            width: width > 786 ? "100%" : 0,
            height: 1,
            backgroundColor: '#80808020'
        }}
    />
}

export default function Nav({ active, update, width }) {
    return (
        <>
            <NavButton current="orders" active={active} update={update}>
                <FiHome size={width > 768 ? 30 : 25} />
            </NavButton>
            <Spacer width={width} />
            <NavButton current="pos" active={active} update={update}>
                <FiPlus size={width > 768 ? 30 : 25} />
            </NavButton>
            <Spacer width={width} />
            <NavButton current="stock" active={active} update={update}>
                <FiTool size={width > 768 ? 30 : 25} />
            </NavButton>
            <Spacer width={width} />
            <NavButton current="settings" active={active} update={update}>
                <FiSettings size={width > 768 ? 30 : 25} />
            </NavButton>
        </>
    )
}